import React from 'react';
import './styles.css';
import CardHelper from '../../helpers';

function CardPremium(props) {
  return (
    <div className={'card card-premiumchannel'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.cover})` }}
          />
          }
          {CardHelper.createBadge(props.badges)}
        </div>
      </div>
    </div>
  );
}

export default CardPremium;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardPremium/index.js